import '../../scss/theme.scss';

import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

import '../filters/currency';
import '../filters/currencyFromCents';
import '../filters/imageSize';
import '../filters/replace';

import '../app';

import '../sections/header';
import '../sections/hero-slider';
import '../sections/featured-collection';
import '../sections/promo-bar-slider';

import '../templates/template-product';
import '../templates/template-collection';
import '../templates/template-search';
import '../templates/template-cart';
import '../templates/template-wishlist';
import '../templates/customers/template-login';
import '../templates/customers/template-addresses';
import '../templates/styleguide';

// Common a11y fixes
focusHash();
bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}